<template>
  <div class="index-page">
    <!-- 首页推荐 -->
    <Recommend :list="calendarRecommendList" />
    <!-- 热门wiki -->
    <WikiList :hotList="moduleList.hotWikiList" :newList="moduleList.newWiki" />
    <!-- 游戏情报 -->
    <News :newsList="moduleList.newsList" :videoList="moduleList.newsVideoList" />
    <!-- 游戏日历 -->
    <GameCalendar :list="calendarList" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import dayjs from "@/plugins/dayjs";

import Recommend from "./components/Recommend.vue";
import WikiList from "./components/WikiList.vue";
import News from "./components/News.vue";
import GameCalendar from "./components/GameCalendar.vue";

// apis
import { apiWwwIndex, apiGetHomeInfoCalendarRecommend, apiGetHomeInfoCalendarList } from "@/api/wwwApi";

// plugins
// import eventBus from "@/plugins/eventBus";
// mixins
import mergeAsyncDataMixin from "@/mixins/mergeAsyncDataMixin";

// 格式化模块数据
function handleModuleList(data) {
  const moduleList = {
    bannerList: [], // 轮播模块
    adList: [], // 广告模块
    newGameList: [], // 新游速递
    manualList: [], // wiki手册
    hotWikiList: [], // 热门wiki
    newsList: [], // 情报
    newsVideoList: [], // 视频情报
    newWiki: [], // 最新wiki
    wikiLib: [], // wiki库
    videoList: [], // 游戏视频
    indexGame: {}, // 新游专区
    contentRecommend: [], // 游戏推荐
    recommendGameList: [] // 首页游戏推荐
  };
  if (data) {
    moduleList.wikiLib = data.wiki_lib;
    moduleList.newWiki = data.new_wiki;
    moduleList.newsList = data.news_list || [];
    moduleList.newsVideoList = data.news_video_list || [];
    moduleList.videoList = data.video_list || [];
    moduleList.indexGame = data.index_game;
    moduleList.recommendGameList = data.recommend_game;
    moduleList.contentRecommend = data.content_recommend;
    data.module_list.forEach(item => {
      if (item.module.type == 1) {
        moduleList.bannerList = item.list;
      } else if (item.module.type == 11) {
        moduleList.adList = item.list;
      } else if (item.module.type == 12) {
        moduleList.newGameList = item.list;
      } else if (item.module.type == 13) {
        moduleList.manualList = item.list;
      } else if (item.module.type == 10) {
        moduleList.hotWikiList = item.list;
      }
    });
  }
  return moduleList;
}

export default {
  name: "index",
  mixins: [mergeAsyncDataMixin],
  props: {},
  model: {},
  components: {
    Recommend,
    WikiList,
    News,
    GameCalendar
  },
  data() {
    return {
      moduleList: handleModuleList(),
      // 服务端获取moduleList
      isSSRGetData: false,
      calendarList: [],
      calendarRecommendList: [],
      hasUserInteraction: false, // 标记用户是否有交互
      hasUserClickEmptyArea: false
    };
  },
  async asyncData({ $apis }) {
    try {
      console.log("asyncData start");
      // 数据预取
      const res = await Promise.all([
        $apis.apiWwwIndex(),
        $apis.apiGetHomeInfoCalendarRecommend(),
        $apis.apiGetHomeInfoCalendarList()
      ]);
      const indexData = res && res[0] ? res[0].data : null;
      const calendarRecommendList = res && res[1] ? res[1].data : [];
      const calendarList = res && res[2] ? res[2].data : [];

      const moduleList = handleModuleList(indexData);

      console.log("asyncData end");
      return {
        moduleList,
        calendarRecommendList,
        calendarList,
        isSSRGetData: true
      };
    } catch (err) {
      console.log(err);
    }
  },
  computed: {
    ...mapGetters(["loginUid", "loginUser", "redPoint", "gameInfo"])
  },
  watch: {},
  created() {},
  beforeMount() {
    // 判断服务端已获取数据
    if (!this.isSSRGetData) {
      this.getData();
    }
  },
  mounted() {
    // console.log(this.calendarList, this.moduleList, this.calendarRecommendList);
    // 访问k站新首页
    if (window.staticFn) window.staticFn.customEvent("visit_new_home_K_station");

    // 监听用户交互事件
    window.addEventListener("click", this.setUserInteraction);
    // 监听页面关闭事件
    window.addEventListener("beforeunload", this.handlePageExit);
  },
  beforeDestroy() {
    // 移除点击事件监听
    window.removeEventListener("click", this.setUserInteraction);
    window.removeEventListener("beforeunload", this.handlePageExit);
  },
  methods: {
    getData() {
      apiWwwIndex().then(({ data }) => {
        this.moduleList = handleModuleList(data);
      });
      apiGetHomeInfoCalendarRecommend().then(({ data }) => {
        this.calendarRecommendList = data;
      });
      apiGetHomeInfoCalendarList().then(({ data }) => {
        this.calendarList = data;
      });
    },
    setUserInteraction(e) {
      const tagetEl = e.target;
      const header = document.querySelector("header");
      const main = document.querySelector("main");
      const footer = document.querySelector("footer");
      // 限定主内容区域
      if (header.contains(tagetEl) || main.contains(tagetEl) || footer.contains(tagetEl)) {
        this.hasUserInteraction = true;
      } else {
        console.log("点击了空白区域");
        this.hasUserClickEmptyArea = true;
      }
    },
    handlePageExit(e) {
      // 用户有点击核心区域
      if (this.hasUserInteraction) {
        console.log("用户有点击核心区域");
      }
      // 用户点击空白区域后关闭页面
      else if (this.hasUserClickEmptyArea) {
        if (window.staticFn) {
          window.staticFn.customEvent("Click_on_blank_new_area_exit");
        }
      }
      // 用户没有进行任何操作就关闭页面
      else {
        // if (window.staticFn) {
        //   window.staticFn.customEvent("user_exit_without_interaction");
        // }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.index-page {
  min-height: 100vh;
}
</style>
